/** Role names used for Overview analytics scope controls. */
export const ADJUSTER_ROLE_NAME = 'Miami Dade Adjuster';
const PRIVILEGED_ROLE_NAMES = new Set([
    'miami dade admin',
    'miami dade manager',
    'miami date manager', // known typo / alias
    'inspire admin',
]);
function normalizeRoleName(roleName) {
    return (roleName ?? '').trim().toLowerCase();
}
export function isOverviewPrivileged(roleName) {
    return PRIVILEGED_ROLE_NAMES.has(normalizeRoleName(roleName));
}
export function isOverviewAdjuster(roleName) {
    return normalizeRoleName(roleName) === normalizeRoleName(ADJUSTER_ROLE_NAME);
}
